import { c as _c } from "react/compiler-runtime";
import React, { useState, useCallback } from 'react';
import { InfoBox } from './InfoBox';
import { InfoBox as InfoBoxType, InfoBoxVariant } from './types';
import { mergeClasses } from '@/utils/style';
export function InfoBoxes(t0) {
  const $ = _c(20);
  const {
    items,
    variant,
    className,
    withCharacters
  } = t0;
  const [openedItem, setOpenedItem] = useState(null);
  let t1;
  if ($[0] !== openedItem) {
    t1 = id => {
      setOpenedItem(openedItem === id ? null : id);
    };
    $[0] = openedItem;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleSectionClick = t1;
  const t2 = withCharacters && "lg:max-w-[97rem] lg:px-28 xl:px-48";
  let t3;
  if ($[2] !== className || $[3] !== t2) {
    t3 = mergeClasses("flex flex-col flex-wrap justify-center gap-2 lg:m-auto lg:max-w-292 lg:flex-row lg:gap-8", t2, className);
    $[2] = className;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== handleSectionClick || $[6] !== items || $[7] !== openedItem || $[8] !== variant || $[9] !== withCharacters) {
    let t5;
    if ($[11] !== handleSectionClick || $[12] !== items.length || $[13] !== openedItem || $[14] !== variant || $[15] !== withCharacters) {
      t5 = (item, index) => <InfoBox {...item} {...withCharacters && (index === 0 ? {
        character: "brain"
      } : index === items.length - 1 && {
        character: "heart"
      })} variant={variant} key={index} isOpen={openedItem === index} onClick={() => handleSectionClick(index)} />;
      $[11] = handleSectionClick;
      $[12] = items.length;
      $[13] = openedItem;
      $[14] = variant;
      $[15] = withCharacters;
      $[16] = t5;
    } else {
      t5 = $[16];
    }
    t4 = items.map(t5);
    $[5] = handleSectionClick;
    $[6] = items;
    $[7] = openedItem;
    $[8] = variant;
    $[9] = withCharacters;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[17] !== t3 || $[18] !== t4) {
    t5 = <div className={t3}>{t4}</div>;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
}